import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  btn: {
    height: 40,

    '& .MuiButton-startIcon>*:nth-of-type(1)': {
      fontSize: 'initial',
    },

    '& .MuiButton-icon': {
      margin: 0,
    },
  },
  activeBtn: {
    background: theme.primary.p3,

    '&.MuiButton-secondary': {
      background: theme.primary.p3,

      '&:disabled': {
        background: theme.background.b1,
      },
    },
  },
  icon: {
    '& img': {
      ...dFlex(),
    },
  },
  chainWithName: {
    ...dFlex(),
    gap: 8,
  },
  chainIcon: {
    width: 24,
    height: 24,
  },
  logo: {
    borderRadius: theme.borderRadius.md,
  },
}));

export default useStyles;
